export default function XSD_Attributes() {
  return (
    <div>
      <h1>XSD_Attributes</h1>
      <p>This is the XSD_Attributes component.</p>
    </div>
  );
}